// @ts-nocheck
import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import TheTree from "../../../tree/TheTree";
import TheHelpTree from "../../../tree/TheHelpTree";
import TheKanbanBoardTree from "../../../tree/TheKanbanBoardTree";
import { connect } from "react-redux";

class CollapsiblePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideTree: false,
      pathname: "",
      helpTree: false,
      kanbanTree: false
    };
  }

  updateDimensions = () => {
    var content = document.getElementsByClassName("content");
    content[0].style.width = "100%";
  };

  componentDidMount() {
    // Check route on mount
    this.updateRouteState();
    
    function initResizeElement() {
      var asides = document.getElementsByClassName("aside");
      var content = document.getElementsByClassName("content");
      var startX, startWidthTextArea, startWidthEditor;
      var p = asides[0];
      p && p.addEventListener("pointerdown", initDrag, false);
      p &&
        p.addEventListener("pointerout", () => {
          p.style.cursor = "default";
        });
      p && p.addEventListener("pointerover", event => {
        if (event.target !== p) return;
        const rect = p.getBoundingClientRect();

        const computedStyles = window.getComputedStyle(p);
        const paddingTop = parseFloat(computedStyles.paddingTop);
        const paddingLeft = parseFloat(computedStyles.paddingLeft);
        const paddingBottom = parseFloat(computedStyles.paddingBottom);
        const paddingRight = parseFloat(computedStyles.paddingRight);

        const contentBoxLeft = rect.left + paddingLeft;
        const contentBoxRight = rect.right - paddingRight;
        const contentBoxTop = rect.top + paddingTop;
        const contentBoxBottom = rect.bottom - paddingBottom;
        const isInPadding =
          event.clientX < contentBoxLeft ||
          event.clientX > contentBoxRight ||
          (event.clientY < contentBoxTop || event.clientY > contentBoxBottom);

        if (isInPadding) {
          p.style.cursor = "ew-resize";
        } else {
          p.style.cursor = "default";
        }
      });

      function initDrag(e) {
        e.stopPropagation();
        startX = e.clientX;
        startWidthTextArea = parseInt(p.getBoundingClientRect().width, 10);
        startWidthEditor = parseInt(content[0].getBoundingClientRect().width, 10);
        document.documentElement.addEventListener("pointermove", doDrag, false);
        document.addEventListener("pointerup", stopDrag, false);
        document.documentElement.style.userSelect = "none";
        document.documentElement.addEventListener("pointerenter", stopDrag, false);
      }

      function doDrag(e) {
        content[0].style.pointerEvents = "none";
        p.style.width = startWidthTextArea + e.clientX - startX + "px";
        if (content[0]) {
          if (startWidthTextArea + e.clientX - startX < startWidthTextArea) {
            content[0].style.width =
              startWidthEditor + Math.abs(startWidthTextArea - (startWidthTextArea + e.clientX - startX)) + "px";
          } else {
            if (startWidthEditor - Math.abs(startWidthTextArea - (startWidthTextArea + e.clientX - startX)) > 300) {
              content[0].style.width =
                startWidthEditor - Math.abs(startWidthTextArea - (startWidthTextArea + e.clientX - startX)) + "px";
            }
          }
        }
      }

      function stopDrag() {
        if (content && content[0]) {
          content[0].style.pointerEvents = "auto";
        }
        document.documentElement.style.userSelect = "";
        document.documentElement.removeEventListener("pointermove", doDrag, false);
        document.documentElement.removeEventListener("pointerup", stopDrag, false);
        document.documentElement.removeEventListener("pointerenter", stopDrag, false);
      }
    }
    window.addEventListener("resize", this.updateDimensions);
    // Listen for route changes
    window.addEventListener("popstate", this.updateRouteState);
    // Also listen for pushState/replaceState changes (since popstate only fires for back/forward)
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      setTimeout(this.updateRouteState, 0);
    };
    
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      setTimeout(this.updateRouteState, 0);
    };
    
    this.originalPushState = originalPushState;
    this.originalReplaceState = originalReplaceState;
    
    initResizeElement();
  }

  updateRouteState = () => {
    const pathname = window.location.pathname;
    
    if (pathname === "/crawler") {
      this.setState({ pathname, hideTree: true, helpTree: false, kanbanTree: false });
    } else if (pathname === "/help" || pathname.includes("/help")) {
      this.setState({ pathname, helpTree: true, kanbanTree: false, hideTree: false });
    } else if (pathname === "/b" || pathname === "/kanboard" || pathname === "/user" || pathname.indexOf("/b/") !== -1) {
      this.setState({ pathname, kanbanTree: true, helpTree: false, hideTree: false });
    } else {
      this.setState({ pathname, kanbanTree: false, helpTree: false, hideTree: false });
    }
  };

  componentWillReceiveProps(nextProps, nextState) {
    // Keep this for backward compatibility, but also update from window.location
    this.updateRouteState();
    
    if (nextProps.boardType !== "DEFAULT" && nextProps.boardType !== this.state.boardType) {
      this.setState({ hideTree: false });
    } else if (
      nextProps.boardType === "DEFAULT" &&
      nextProps.boardType !== this.state.boardType &&
      this.state.kanbanTree
    ) {
      this.setState({ hideTree: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.removeEventListener("popstate", this.updateRouteState);
    // Restore original history methods
    if (this.originalPushState) {
      history.pushState = this.originalPushState;
    }
    if (this.originalReplaceState) {
      history.replaceState = this.originalReplaceState;
    }
  }

  componentDidUpdate = () => {
    const aside = document.getElementById("aside");
    if (!aside.className && !this.state.hideTree) {
      aside.setAttribute("class", "aside");
    }
    this.updateDimensions();
  };

  togglePanel = () => {
    this.setState({ hideTree: !this.state.hideTree });
    const aside = document.getElementById("aside");
    aside.style.width = null;
    const content = document.getElementById("content");
    if (!this.state.hideTree) {
      content.style.width = "100%";
      aside.removeAttribute("class");
    } else {
      content.style.width = null;
      aside.setAttribute("class", "aside");
    }
  };

  render() {
    const { hideTree, helpTree, kanbanTree, pathname } = this.state;
    var isRouteOfHelp = false;
    const match = window.location.pathname.split("/");
    if (match.includes("help")) {
      isRouteOfHelp = true;
    }

    if (
      this.props.boardType === "DEFAULT" &&
      (["/user"].includes(pathname) || ["/kanboard"].includes(pathname) || pathname.indexOf("/b/") !== -1)
    ) {
      return null;
    }

    if (hideTree) {
      return (
        <Paper style={{ backgroundColor: "#6e90ff", height: "fit-content" }}>
          <IconButton aria-label="Expand" onClick={() => this.togglePanel()}>
            <Icon className="fas fa-angle-double-right" fontSize="medium" />
          </IconButton>
        </Paper>
      );
    } else if (helpTree || isRouteOfHelp) {
      return (
        // <div className="aside">
        <TheHelpTree togglePanel={this.togglePanel} />
        // </div>
      );
    } else if (kanbanTree || pathname.indexOf("/b/") !== -1) {
      return (
        // <div className="aside">
        <TheKanbanBoardTree togglePanel={this.togglePanel} />
        // </div>
      );
    } else {
      return (
        <React.Fragment>
          {window.location.pathname !== "/kanboard" && window.location.pathname !== "/user" && (
            // <div className="aside">
            <TheTree togglePanel={this.togglePanel} />
            // </div>
          )}
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ boardType }) => ({
  boardType: boardType || "DEFAULT"
});

export default connect(mapStateToProps)(CollapsiblePanel);
